"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const normalizeFieldDefinitions_1 = __importDefault(require("./normalizeFieldDefinitions"));
const normalizeAuthFields = (fields) => {
    return normalizeFieldDefinitions_1.default(fields).map(field => {
        return field.hasOwnProperty('required')
            ? field
            : Object.assign(Object.assign({}, field), { required: true });
    });
};
exports.default = normalizeAuthFields;
